
<template>
	<div ref="listWrap">
		<wrapper-list
		 @add="paasAddPage"
        @calculate="paasCalculate"
		ref="wrapperList" >
      	<Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
            <row class="list-query-row">
                <FormItem label="特惠活动名称" class="list-query-item ivu-col-span-12">
                    <Input  v-model="queryParam.query_LIKE_name" placeholder=""
                        @on-change="queryTableDatas" clearable />
                </FormItem>
            </row>
      	</Form>
      	<Table slot="table" stripe border :height="tableHeight"
             :data="tableData"
             :columns="tableColumns"
             @on-selection-change="selectTableDataChange"
             @on-sort-change="sortTableData"
             :no-data-text="noDataText">
        </Table>
        <Page slot="page"  :total="totalRecords"
            show-total show-sizer
            @on-change="changePage"
            @on-page-size-change="changePageSize">
        </Page>
        </wrapper-list>
   </div>
</template>
<script>
	import wrapperList from "@/components/paas/wrapper-list";
    import metaList from "@/assets/js/list/meta-list.js";
    import CellBar from '@/components/paas/cell-bar' //列表内操作
    export default {
      name: "list",
      mixins: [ metaList ],
      components: { wrapperList  ,CellBar},
      data() {
      	return {
      		serviceUrl:"/eb/store/product/discount",  //每个页面访问后台服务器的路径
      		currentIdFiledName: 'id',
      		queryParam:{
   				query_LIKE_name:"",
	        },
	        defaultLabelWidth:200,
	         tableColumns:[
	        	{
	        		title: '特惠活动名称',
	        		key: 'name',
	        	},
	        	{
	        		title: '活动开始日期',
	        		key: 'dateStart',
	        	},
	        	{
	        		title: '活动结束日期',
	        		key: 'dateEnd',
	        	},
	        	{
	        		title: '操作',
	        		render: (h, params) => {
		                return h(CellBar,
		                    {
			                  props:{
			                    show:'textIcon'  //操作也显示标准按钮的样式（text、icon、textIcon）
			                  },
			                  //自定义事件监听器“on”,不支持如v-on:keyup.enter的修饰符，需要手动匹配keyCode
			                    on: {
                                  // 子组件$emit传递函数,必须是箭头函数写法
                                  'edit': ()=> {
                                    this.$nextTick(()=>{
                                        this.paasEditOper(params.row[this.currentIdFiledName]);
                                    })
                                  },
			                      'delete':()=>{
			                        this.$nextTick(()=>{
			                          this.paasDeleteOper(params.row[this.currentIdFiledName]);
			                        })
			                      },
			                      'detail':()=>{
			                        this.$nextTick(()=>{
			                          this.paasDetailOper(params.row[this.currentIdFiledName]);
			                        })
			                      },
                                  'addGoods':()=>{
                                    this.$nextTick(()=>{
                                        this.$router.push({
                                            name:"ebDiscountProductAdd",
                                            params: {
                                                updateData: [params.row]
                                            },
                                            query: {
                                                paasCurrentFunctionId: this.$route.query[this.$store.state.funcIdName]
                                            },
                                        })
                                    })
                                  }
			                    }
			                }
			            )
		            }
		         }
	        ],
      	}
      },
      mounted(){
      },
      methods:{
      }
    }
</script>
